import { UrlList } from '..';
import { KbArticle } from '../../../types';

/**
 * Renders the list of kb artickles to a list of clickable links.
 */
export const ArticleList = ({ list }: { list: KbArticle[] }) => (
  <UrlList list={list} nameKey={'articleName'} urlKey={'articleUrl'} />
);

/**
 * Renders the list of kb artickles' "download" links to a
 * list of clickable links.
 */
export const DownloadList = ({ list }: { list: KbArticle[] }) => (
  <UrlList list={list} nameKey={'downloadName'} urlKey={'downloadUrl'} />
);
